import React, { useState } from 'react';
import {
    FaBook,
    FaBookOpen,
    FaFilePdf,
    FaChevronDown,
    FaChevronRight,
    FaCopy
} from 'react-icons/fa';
import './CourseStructurePreview.css'; // Reuse existing styles

const EbookStructurePreview = ({ chapters }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const calculateTotalPages = () => {
        return chapters.reduce((total, chapter) => total + (chapter.pageCount || 0), 0);
    };

    if (!chapters || chapters.length === 0) {
        return null;
    }

    return (
        <div className="structure-preview">
            <div className="preview-header">
                <h3>Ebook Structure Preview</h3>
                <div className="course-stats">
                    <span className="stat-item">
                        <FaBook /> {chapters.length} Chapter{chapters.length !== 1 ? 's' : ''}
                    </span>
                    <span className="stat-item">
                        <FaCopy /> {calculateTotalPages()} Page{calculateTotalPages() !== 1 ? 's' : ''}
                    </span>
                </div>
            </div>

            <div className="preview-tree">
                <div className="tree-module">
                    <div className="tree-item module-item">
                        <button
                            type="button"
                            className="tree-expand-btn"
                            onClick={toggleExpand}
                        >
                            {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
                        </button>
                        <div className="tree-item-icon module-icon-preview">
                            {isExpanded ? <FaBookOpen /> : <FaBook />}
                        </div>
                        <div className="tree-item-content">
                            <span className="tree-item-title">
                                Ebook Content
                            </span>
                            <span className="tree-item-meta">
                                <span className="duration-badge">
                                    <FaCopy /> {calculateTotalPages()} Pages
                                </span>
                            </span>
                        </div>
                    </div>

                    {isExpanded && (
                        <div className="tree-children">
                            {chapters.map((chapter, index) => (
                                <div key={chapter._id || index} className="tree-item lesson-item">
                                    <div className="tree-item-spacer"></div>
                                    <div className="tree-item-icon lesson-icon-preview">
                                        <FaFilePdf />
                                    </div>
                                    <div className="tree-item-content">
                                        <span className="tree-item-title">
                                            {chapter.title || `Chapter ${index + 1}`}
                                        </span>
                                        <span className="tree-item-meta">
                                            {chapter.pageCount > 0 && (
                                                <span className="duration-badge">
                                                    <FaCopy /> {chapter.pageCount} Pages
                                                </span>
                                            )}
                                            {chapter.pdfFile && typeof chapter.pdfFile === 'string' && (
                                                <a
                                                    href={chapter.pdfFile}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="video-badge"
                                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    View PDF
                                                </a>
                                            )}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EbookStructurePreview;
